import api from 'api';

export const MENU_ANALYSIS_ASYNC_ACTION_START = 'MENU_ANALYSIS_ASYNC_ACTION_START';
export const MENU_ANALYSIS_ASYNC_ACTION_ERROR = 'MENU_ANALYSIS_ASYNC_ACTION_ERROR';
export const MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS = 'MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS';
export const MENU_ANALYSIS_UPDATE_SUCCESS = 'MENU_ANALYSIS_UPDATE_SUCCESS';
export const MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS = 'MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS';
export const MENU_ANALYSIS_CLONE_SUCCESS = 'MENU_ANALYSIS_CLONE_SUCCESS';
export const MENU_ANALYSIS_RESET_STATE = 'MENU_ANALYSIS_RESET_STATE';

function menuAnalysisAsyncActionStart() {
  return {
    type: MENU_ANALYSIS_ASYNC_ACTION_START,
  };
}

function menuAnalysisAsyncActionError(error) {
  return {
    type: MENU_ANALYSIS_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuAnalysisAsyncUpdateSuccess(data) {
  return {
    type: MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function menuAnalysisUpdateSuccess() {
  return {
    type: MENU_ANALYSIS_UPDATE_SUCCESS,
  };
}

export function menuAnalysisUpdate(data) {
  return {
    type: MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

export function updateMenuItemsAnalysisKeyValue(categoryId, menuItemId, key, value) {
  return {
    type: MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS,
    categoryId,
    menuItemId,
    key,
    value,
  };
}

export function cloneMenuAnalysis(data) {
  return {
    type: MENU_ANALYSIS_CLONE_SUCCESS,
    data,
  };
}

export function resetmenuAnalysisState() {
  return {
    type: MENU_ANALYSIS_RESET_STATE,
  }
}

/**
 * fetch menu analysis data for profit calculator
 * for a given period
 * @param {*} menuId 
 * @param {*} periodId 
 */
export function getMenuAnalysisAsync(menuId, periodId) {
  return (dispatch, getState) => {
    dispatch(menuAnalysisAsyncActionStart());
    return api.request(`menuAnalysis/createGet?menuId=${ menuId }&periodId=${ periodId }`, 'get')
    .then((data) => {
      dispatch(menuAnalysisAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuAnalysisAsyncActionError('Unable to get Menu Analysis'));
      throw (err);
    });
  };
}

export function clearMenuAnalysisAsync(menuId) {
  return (dispatch, getState) => {
    dispatch(menuAnalysisAsyncActionStart());
    return api.request(`menuAnalysis/${ menuId }`, 'delete')
    .then((data) => {
      dispatch(menuAnalysisUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAnalysisAsyncActionError('Unable to clear Menu Analysis'));
      throw (err);
    });
  };
}

// MenuAnalysis Level -- menuItemAnalysisList is for price, cost, quantity, profit of Menu Analysis
export function updateMenuAnalysisAsync(menuAnalysis) {
  return (dispatch, getState) => {
    dispatch(menuAnalysisAsyncActionStart());
    return api.request('menuAnalysis/menuItemAnalysisList', 'put', menuAnalysis)
    .then((data) => {
      dispatch(menuAnalysisUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAnalysisAsyncActionError('Unable to update Menu Analysis'));
      throw (err);
    });
  };
}

// MenuAnalysis Level -- menuAnalysisData is for profitPercent, pricePercent, salesPercent
export function updateMenuAnalysisPercentAsync(menuAnalysis) {
  return (dispatch, getState) => {
    dispatch(menuAnalysisAsyncActionStart());
    return api.request('menuAnalysis/menuAnalysisData', 'put', menuAnalysis)
    .then((data) => {
      dispatch(menuAnalysisUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAnalysisAsyncActionError('Unable to update Menu Analysis Percent'));
      throw (err);
    });
  };
}

// menuAnalysis updated for Menu Item Analysis Level
export function updateMenuItemAnalysisAsync(menuItemAnalysis, periodId) {
  return (dispatch, getState) => {
    dispatch(menuAnalysisAsyncActionStart());
    return api.request(`menuAnalysis?periodId=${ periodId }`, 'put', menuItemAnalysis)
    .then((data) => {
      dispatch(menuAnalysisUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuAnalysisAsyncActionError('Unable to update Menu Item Analysis'));
      throw (err);
    });
  };
}
